import React from "react";

import { Controller, useFormContext } from "react-hook-form";

import { Select } from "src/base-components/Select";
import { Switch } from "src/base-components/Switch";
import {
  CustomConnectionForm,
  PostprocessingType,
} from "src/customConnectionNode/types";

type PostprocessingConfigurationProps = {
  immutable: boolean;
};

const postprocessingOptions: {
  key: PostprocessingType;
  value: string;
  description: string;
}[] = [
  {
    key: "camel_to_snake",
    value: "Camel to snake case",
    description: "",
  },
  {
    key: "kebab_to_snake",
    value: "Kebab to snake case",
    description: "",
  },
  {
    key: "xml_to_json",
    value: "XML to JSON",
    description: "",
  },
];

export const PostprocessingConfiguration: React.FC<
  PostprocessingConfigurationProps
> = ({ immutable }) => {
  const { control, watch } = useFormContext<CustomConnectionForm>();
  const isActive = watch("config.postprocessing_config.active");

  return (
    <div className="mt-6">
      <div className="flex items-center justify-between">
        <div>
          <h3 className="font-inter-medium-12px text-gray-800">
            Response postprocessing
          </h3>
          <span className="font-inter-normal-12px text-gray-500">
            Apply a transformation to the response body
          </span>
        </div>
        <Controller
          control={control}
          name="config.postprocessing_config.active"
          render={({ field }) => (
            <Switch
              dataLoc="custom-connection-node-postprocessing-active"
              disabled={immutable}
              enabled={field.value}
              onChange={() => {
                field.onChange(!field.value);
              }}
            />
          )}
        />
      </div>
      {isActive && (
        <div className="mt-4 flex w-full flex-row items-center justify-between rounded-lg bg-gray-50 px-5 py-4">
          <span className="mr-2 font-inter-normal-12px text-gray-700">
            Transformation
          </span>
          <Controller
            control={control}
            name="config.postprocessing_config.type"
            render={({ field }) => (
              <Select
                dataLoc="custom-connection-node-postprocessing-type"
                disabled={immutable}
                options={postprocessingOptions}
                placeholder="Select transformation"
                value={field.value ?? undefined}
                onChange={(value) => {
                  field.onChange(value as PostprocessingType);
                }}
              />
            )}
          />
        </div>
      )}
    </div>
  );
};
